import { CardSection, CardHeader } from '@europrocurement/flexy-components';
import * as React from 'react';
import { PrescriberTabProps } from './types';

const Activities: React.FunctionComponent<PrescriberTabProps> = function () {
    const cardHeader = (
        <CardHeader
            title="Activités"
            border={false}
        />
    );
    return <CardSection header={cardHeader}>Activités ...</CardSection>;
};

export default Activities;
